// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  font-family: "Raleway", sans-serif !important  ;
  font-weight: 400;
  color: var(--secondry-color);
  scroll-behavior: smooth;
  line-height: 1.5;
  letter-spacing: 0.8px;
}

:root {
  --primary-color: #fdb508;
  --third-color: #f48a0f;
  --secondary-color-1: #327171;
  --secondry-color: #495057;
  --white-color: #fff;
  --black-color: #000;
}

.custom-select:focus,
.form-control:focus,
.btn:focus {
  border-color: var(--primary-color);
  outline: 0;
  box-shadow: none !important;
}

/* Header css */
.navbar {
  height: 70px;
  background-color: var(--white-color);
  box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;
}

.navbar .navbar-brand {
  color: var(--secondary-color-1) !important;
  font-weight: 600;
}

.navbar .nav-link,
.navbar .dropdown-item {
  font-size: 15px;
  font-weight: 400;
  color: var(--secondry-color);
}

.navbar .nav-link:hover,
.navbar .dropdown-item:hover,
.navbar .dropdown-item:focus {
  color: var(--primary-color);
  background-color: var(--white-color);
  text-decoration: none !important;
}

/* page css */
.main-wrapper {
  display: block;
  /* background-color: #d1cecedd; */
  min-height: 100vh;
  padding-top: 20px;
}

.action-btn {
  border: 1px solid var(--secondary-color-1);
  font-size: 15px;
  padding: 10px 15px;
  color: var(--black-color);
  background-color: var(--white-color);
  cursor: pointer;
}

.action-btn:hover,
.action-btn:focus {
  background-color: var(--secondary-color-1) !important;
  border-color: var(--secondary-color-1) !important;
  color: var(--white-color);
}

.filter-sec,
.search-bar {
  height: auto;
  padding: 10px;
  font-size: 15px;
  border-color: var(--secondary-color-1);
}
.form-control.filter-sec:focus,
.form-control.filter-sec:focus:hover,
.search-bar:focus,
.search-bar:hover {
  border: 1px solid var(--secondary-color-1);
}

.input-group-append .action-btn {
  background-color: var(--secondary-color-1);
  color: var(--white-color);
}

.input-group-append .action-btn:hover {
  background-color: var(--white-color) !important;
  color: var(--black-color);
}

/* main section */
.main-wrapper {
  margin-top: 70px;
}
.main-section {
  padding-top: 50px;
}

.main-section table th,
.main-section table td {
  vertical-align: middle;
  font-size: 13px;
  font-weight: 400;
  color: var(--secondry-color);
}

.main-section table th {
  font-weight: 600;
  color: var(--black-color);
}

 /* .edit-icon {
  display: flex;
  align-items: center;
  margin-left: auto;
} */

/* .main-section .edit-icon input {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  margin-right: 10px;
  border-color: var(--black-color);
} */

/* .main-section .edit-icon svg {
  font-size: 18px;
} */

.main-section .action-btn,
.submit-button {
  padding: 5px 20px;
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

/* Client detail view page*/

.main-wrapper .card {
  box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;
  border-radius: 20px;
}

.main-wrapper h4 {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: normal;
  color: var(--secondry-color);
}

.client-detail-sec .client-pic {
  width: 150px;
  height: 150px;
  margin: auto;
  border-radius: 50%;
  border: 2px solid var(--secondary-color-1);
}

.client-detail-sec .client-pic img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}

.client-detail-sec th,
.client-detail-sec td {
  border: 0;
}
.deleteButton {
  font-size: 30px;
  color: red;
  margin-left: 8px;
}
.page-loader {
  width: 100%;
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--white-color);
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.disabledButton {
  cursor: not-allowed;
}
.pointer {
  cursor: pointer;
}
.danger {
  color: red;
}
.client_email {
  max-width: 170px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
  margin-bottom: 0;
}
/* dashboard */
.dashboard-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: 20px;
}

.dashboard-container > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}

.dashboard-container > div:first-child {
  background-color: transparent;
  box-shadow: none;
}

.dashboard-container input[type="date"] {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
  width: 100%;
  max-width: 250px;
}

.dashboard-container button {
  border: none;
  border-radius: 5px;
  background-color: #5cb85c;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.dashboard-container button:hover {
  background-color: #449d44;
}

.dashboard-container-center-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  width: 100%;
  max-width: 50%;
}

.dashboard-container > div:first-child {
  justify-content: flex-end;
  gap: 10px;
}

.my-div {
  animation: fade-in-and-slide 0.5s ease-in-out both;
  opacity: 0;
  transform: translateY(-20px);
}

.check {
  border: 1px solid teal;
  width: 400px;
}

@keyframes fade-in-and-slide {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.check {
  border: 1px solid teal;
  width: 400px;
}
.added-data-list {
  width: 93%;
  margin-top: 0.1rem;
  list-style-type: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.added-data-list li {
  position: relative;
  margin-top: 0.5rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background-color: #f3f3f3;
}

.added-data-list li .close-icon {
  position: absolute;
  top: 50%;
  right: 0rem;
  transform: translateY(-50%);
}
.close-icon {
  margin-right: 10px;
  cursor: pointer;
  z-index: 5;
}

.edit-icon:hover svg {
  color: var(--primary-color);
  /* cursor: pointer; */
}
.no-data {
  font-size: 27px;
  margin-top: 40px;
  font-weight: 500;
}

.multi-select .dropdown-container {
  border: 1px solid #ced4da !important;
}

.multi-select .dropdown-container:focus-within {
  box-shadow: none !important;
  border-color: var(--primary-color) !important;
}

.dropdown-heading-value span {
  color: #495057 !important;
}
.chart-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
button.chakra-button:hover {
  color: #000;
  background-color: #fdb508;
  border-color: #fdb508;
}
.addButton {
  font-size: 22px;
  color: blue;
  margin-left: 8px;
}
.lead_analytics {
  border: 2px solid rgb(229, 229, 229);
  height: 450px;
}
.lower_analytics_div {
  margin: 45px 0;
  display: flex;
  justify-content: space-around;
}
.lower_analytics_div > div:first-child {
  padding: 10px 25px;
  width: 250px;
  font-weight: bold;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  color: white;
  cursor: pointer;
}
.lower_analytics_div > div:last-child {
  text-shadow: 1px 1px 1px #000, 3px 3px 5px blue;
}

.week_div {
  margin: 10px 0;
}
.leads_data_analytics {
  height: 350px;
  overflow-y: scroll;
}
.list_section {
  padding-top: 10px;
}
.custom_chart {
  height: 350px;
  display: flex;
  justify-content: space-around;
}
.custom_chart > div > div {
  width: 120px;
  height: 100%;
}
.custom_bar {
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
}
.heading {
  display: flex;
  justify-content: space-around;
  font-weight: 900;
  margin-bottom: 10px;
}
.icon {
  font-size: 25px;
}
.table_analytics {
  height: 340px;
  overflow-y: scroll;
}
.table_analytics > div {
  display: flex;
  justify-content: space-around;
}
.table_analytics > div > div:first-child {
  padding: 10px 5px;
  margin-top: 3px;
  width: 250px;
  font-weight: bold;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  color: white;
}
.table_analytics > div > div:last-child {
  font-weight: 900;
  font-size: 28px;
  text-shadow: 1px 1px 1px #000, 3px 3px 5px blue;
}
.monthly_analytics_div {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
.flex {
  display: flex;
  justify-content: space-between;
  font-size: 25px;
  text-align: center;
  align-items: center;
}
.custom_chart_analytics {
  border: 2px solid rgb(229, 229, 229);
  padding: 5px;
  display: flex;
  justify-content: space-around;
}

.custom_bar_analytics {
  height: 550px;
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
}
.date-range-picker {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.date-range-picker input[type="date"] {
  margin-left: 15px;
  font-size: 16px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.date-range-picker button {
  background-color: #327171;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;
  margin-left: 10px;
}

.date-range-picker button:hover {
  background-color: #fdb508;
}
.monthly_lead_heading {
  text-align: center;
  margin-top: 50px;
}
.monthly_lead_heading > h3 {
  color: black;

  text-shadow: 3px 3px 20px #c3d6c3, -2px 1px 30px #c3d6c3;
  font-weight: 900;
}
.monthly_table_analytics {
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 10px;
}
.monthly_table_analytics > div {
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;
  border-bottom: 1px solid #c3d6c3;
  margin: 10px;
}
.monthly_table_analytics > div > div:first-child {
  width: 80%;
  text-align: left;
}
.monthly_table_analytics > div > div:last-child {
  width: 20%;
  text-align: right;
  font-weight: 700;
}

.pie_heading {
  width: 120px;
  margin: auto;
  text-align: center;
  padding: 10px 0;
  background-color: #219ff3;
  font-weight: bold;
  font-size: 24px;
  color: #fff;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  letter-spacing: 1px;
}
.week_days {
  border: 1px solid teal;
  padding: 5px 10px;
  border-radius: 50%;
  margin: 0 10px;
}
.clicked_week_days {
  background-color: #327171;
  color: white;
  font-weight: 700;
}
.expert_time {
  margin-top: 15px;
}
.centered-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 150px);
  overflow: auto;
}

.custom-table {
  width: 50%;
  max-width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.custom-table th,
.custom-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
.custom-table th {
  background-color: #f2f2f2;
}

.custom-table tr:last-child td {
  border-bottom: none;
}

.table-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.time-slots {
  width: 50%;
}

.tdEditIcon {
  cursor: pointer;
}

.statusCell {
  display: flex;
  align-items: center;
}

.booking-table-th {
  width: 50% !important;
  border: 10px solid red;
}

.expert-pricing-div {
  margin-top: 50px;
}

.expert-pricing-lower-div {
  margin: 50px 0px 0 0;
  background: #327171;
  border-radius: 8px;
}
.expert-timing-lower-div {
  border: 1px solid teal;
  display: flex;
  justify-content: space-evenly;
  text-align: center;
}
.expert-timing-lower-div > :first-child {
  width: 100px;
  height: 80px;
  border-radius: 50%;
}
.expert-timing-lower-div > :first-child > img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.expert-timing-lower-div > :last-child {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.our-team {
  padding: 20px 0 20px;
  background: white;
  text-align: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.our-team .pic {
  display: inline-block;
  width: 130px;
  height: 130px;
  margin-bottom: 50px;

  position: relative;
  z-index: 1;
}

.our-team .pic:before {
  content: "";
  width: 100%;
  background: #327171;
  position: absolute;
  bottom: 135%;
  right: 0;
  left: 0;
  transform: scale(3);
  transition: all 0.3s linear 0s;
}

.our-team .pic:before {
  height: 100%;
}

.our-team .pic:after {
  content: "";
  width: 100%;
  height: 100%;
  border: radius 50%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.our-team .pic img {
  width: 100%;
  height: auto;
  border-radius: 50%;
  transform: scale(1);
  transition: all 0.9s ease 0s;
}

.our-team .pic img {
  box-shadow: 0 0 0 14px #efdb07;
  transform: scale(0.7);
}

.our-team .team-content {
  margin-bottom: 50px;
  /* color: white; */
}

.our-team .title {
  font-size: 22px;
  font-weight: 700;
  color: white;
  letter-spacing: 1px;
  text-transform: capitalize;
  margin-bottom: 5px;
  text-shadow: 5px 5px 5px black;
}

.our-team .post {
  display: block;
  font-size: 15px;
  color: white;
  text-transform: capitalize;
  text-shadow: 5px 5px 5px black;
}

.our-team .social {
  width: 100%;
  padding: 10px 0 0 0;
  margin: 0;
  background: #327171;
  position: absolute;
  bottom: -100px;
  left: 0;
  transition: all 0.5s ease 0s;
}

.our-team .social {
  bottom: 0;
}

.our-team .social li {
  display: inline-block;
}

.our-team .social li a {
  display: block;
  padding: 10px;
  font-size: 24px;
  color: white;
  cursor: pointer;
  transition: all 0.5s ease 0s;
}

.our-team .social li a {
  color: white;
  text-decoration: none;
}

.expert_div {
  background: #327171;
  /* border: 1px solid red; */
  border-radius: 4px;
}

.active-status {
  font-weight: 700 !important;
  color: green !important;
}

.ended-status {
  font-weight: 700 !important;
  color: red !important;
}

.button-icon {
  font-size: 20px;
}

.corporate-grid-container {
  margin-top: 80px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  padding: 0 10px;
}

.corporate-grid-item {
  padding: 20px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  text-align: center;
}
.custom-navbar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  background-color: #f8f9fa;
  display: grid !important;
}

.navbar-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #e9ecef;
}

.navbar-top .brand {
  text-align: center;
  flex: 1 1;
}

.navbar-top .logout-btn {
  flex: 0 1;
  margin-left: auto;
}

.navbar-bottom {
  padding: 0.5rem 1rem;
}

@media (max-width: 767px) {
  .navbar-top {
    flex-direction: row-reverse;
    justify-content: space-between;
  }

  .navbar-top .brand {
    order: 1;
    flex: 1 1;
    text-align: center;
  }

  .navbar-top .logout-btn {
    order: 2;
  }
}
.container-fluid {
  margin-top: -60px;
}
.top_section_container {
  display: flex;
  column-gap: 25px;
}

.expert_container_item {
  padding: 10px;
  flex: 1 1;
}

.expert_list_button {
  display: flex;
  justify-content: right;
  align-items: center;
}

.expert_list_button > div {
  margin-right: 15px;
}
.centered_text {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #327171;
}

.expert_centered_text {
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #327171;
}

.centered {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.top_section_lower_container {
  flex: 1 1;
}
.small_item {
  flex: 0.65 1;
}

.wide_item {
  flex: 1.15 1;
}

/* .master_wide_item {
  flex: 1.15; 
} */

.nested {
  margin-bottom: 10px;
}

.nested:last-child {
  margin-bottom: 0;
}

.subscription_clear_button {
  width: 330px;
}

.single_centered_text {
  margin-top: 20px;
  font-size: 30px;
}

.sheet_btn,
.sheet_btn:focus {
  background-color: var(--secondary-color-1);
  border: 1px solid var(--secondary-color-1);
}

.sheet_btn:hover {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: var(--white-color);
}

.small-text {
  font-size: 0.8em;
  color: gray;
  word-break: break-all;
  overflow-wrap: break-word;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.notifications-title {
  flex-grow: 1;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--secondary-color-1);
}

.vertical-buttons {
  display: flex;
  flex-direction: column;
}

.no-data {
  text-align: center;
  padding: 1rem;
}

.notification-table-container {
  overflow-x: auto;
  flex: 1 1;
  border-left: 2px solid #c6caca;
  padding-left: 2rem;
}

.notification-btn {
  display: block;
  width: 100%;
}

.notification-action-btn {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.custom-btn {
  width: 220px;
}

.sync-text {
  font-weight: bold;
  font-size: small;
  margin: 5px 5px 5px 10px;
}
.sync-subtext {
  font-weight: normal;
  font-size: smaller;
  margin: 5px 5px 5px 10px;
}

.sync-count {
  color: #327171;
}

.info-icon {
  cursor: pointer;
}

.info-content {
  visibility: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  z-index: 10;
}

.info-icon:hover + .info-content {
  visibility: visible;
}

.parent-sync-count {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 10px;
}

.lower_parent-booking-count {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  padding-top: 5px;
}

.mt-records {
  font-size: 20px;
  font-weight: bold;
  color: #327171;
  margin: 25px 0 50px 0;
}

.center-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;;EAEE,+CAA+C;EAC/C,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,kCAAkC;EAClC,UAAU;EACV,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;;EAGE,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;EAEE,qDAAqD;EACrD,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,sCAAsC;AACxC;AACA;;;;EAIE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;CAEC;;;;GAIE;;AAEH;;;;;;GAMG;;AAEH;;GAEG;;AAEH;;EAEE,iBAAiB;EACjB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA,2BAA2B;;AAE3B;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;AACX;AACA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,4CAA4C;EAC5C,YAAY;EACZ,eAAe;AACjB;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,4CAA4C;EAC5C,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;;EAEZ,wDAAwD;EACxD,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;;EAEnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,SAAS;;EAET,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,QAAQ;IACR,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;AACA;EACE,YAAU;AACZ;;AAEA;EACE,YAAU;AACZ;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200&display=swap\");\n\nbody,\nhtml {\n  font-family: \"Raleway\", sans-serif !important  ;\n  font-weight: 400;\n  color: var(--secondry-color);\n  scroll-behavior: smooth;\n  line-height: 1.5;\n  letter-spacing: 0.8px;\n}\n\n:root {\n  --primary-color: #fdb508;\n  --third-color: #f48a0f;\n  --secondary-color-1: #327171;\n  --secondry-color: #495057;\n  --white-color: #fff;\n  --black-color: #000;\n}\n\n.custom-select:focus,\n.form-control:focus,\n.btn:focus {\n  border-color: var(--primary-color);\n  outline: 0;\n  box-shadow: none !important;\n}\n\n/* Header css */\n.navbar {\n  height: 70px;\n  background-color: var(--white-color);\n  box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;\n}\n\n.navbar .navbar-brand {\n  color: var(--secondary-color-1) !important;\n  font-weight: 600;\n}\n\n.navbar .nav-link,\n.navbar .dropdown-item {\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--secondry-color);\n}\n\n.navbar .nav-link:hover,\n.navbar .dropdown-item:hover,\n.navbar .dropdown-item:focus {\n  color: var(--primary-color);\n  background-color: var(--white-color);\n  text-decoration: none !important;\n}\n\n/* page css */\n.main-wrapper {\n  display: block;\n  /* background-color: #d1cecedd; */\n  min-height: 100vh;\n  padding-top: 20px;\n}\n\n.action-btn {\n  border: 1px solid var(--secondary-color-1);\n  font-size: 15px;\n  padding: 10px 15px;\n  color: var(--black-color);\n  background-color: var(--white-color);\n  cursor: pointer;\n}\n\n.action-btn:hover,\n.action-btn:focus {\n  background-color: var(--secondary-color-1) !important;\n  border-color: var(--secondary-color-1) !important;\n  color: var(--white-color);\n}\n\n.filter-sec,\n.search-bar {\n  height: auto;\n  padding: 10px;\n  font-size: 15px;\n  border-color: var(--secondary-color-1);\n}\n.form-control.filter-sec:focus,\n.form-control.filter-sec:focus:hover,\n.search-bar:focus,\n.search-bar:hover {\n  border: 1px solid var(--secondary-color-1);\n}\n\n.input-group-append .action-btn {\n  background-color: var(--secondary-color-1);\n  color: var(--white-color);\n}\n\n.input-group-append .action-btn:hover {\n  background-color: var(--white-color) !important;\n  color: var(--black-color);\n}\n\n/* main section */\n.main-wrapper {\n  margin-top: 70px;\n}\n.main-section {\n  padding-top: 50px;\n}\n\n.main-section table th,\n.main-section table td {\n  vertical-align: middle;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--secondry-color);\n}\n\n.main-section table th {\n  font-weight: 600;\n  color: var(--black-color);\n}\n\n /* .edit-icon {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n} */\n\n/* .main-section .edit-icon input {\n  width: 20px;\n  height: 20px;\n  border-radius: 5px;\n  margin-right: 10px;\n  border-color: var(--black-color);\n} */\n\n/* .main-section .edit-icon svg {\n  font-size: 18px;\n} */\n\n.main-section .action-btn,\n.submit-button {\n  padding: 5px 20px;\n  background-color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n\n/* Client detail view page*/\n\n.main-wrapper .card {\n  box-shadow: rgb(0 0 0 / 16%) 1px 1px 10px;\n  border-radius: 20px;\n}\n\n.main-wrapper h4 {\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: normal;\n  color: var(--secondry-color);\n}\n\n.client-detail-sec .client-pic {\n  width: 150px;\n  height: 150px;\n  margin: auto;\n  border-radius: 50%;\n  border: 2px solid var(--secondary-color-1);\n}\n\n.client-detail-sec .client-pic img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.client-detail-sec th,\n.client-detail-sec td {\n  border: 0;\n}\n.deleteButton {\n  font-size: 30px;\n  color: red;\n  margin-left: 8px;\n}\n.page-loader {\n  width: 100%;\n  height: calc(100vh - 70px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--white-color);\n}\n\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n}\n.disabledButton {\n  cursor: not-allowed;\n}\n.pointer {\n  cursor: pointer;\n}\n.danger {\n  color: red;\n}\n.client_email {\n  max-width: 170px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow-x: hidden;\n  margin-bottom: 0;\n}\n/* dashboard */\n.dashboard-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  margin: 20px;\n}\n\n.dashboard-container > div {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px;\n  background-color: #f5f5f5;\n  border-radius: 5px;\n  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-container > div:first-child {\n  background-color: transparent;\n  box-shadow: none;\n}\n\n.dashboard-container input[type=\"date\"] {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 16px;\n  width: 100%;\n  max-width: 250px;\n}\n\n.dashboard-container button {\n  border: none;\n  border-radius: 5px;\n  background-color: #5cb85c;\n  color: #fff;\n  padding: 10px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.dashboard-container button:hover {\n  background-color: #449d44;\n}\n\n.dashboard-container-center-div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  width: 100%;\n  max-width: 50%;\n}\n\n.dashboard-container > div:first-child {\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.my-div {\n  animation: fade-in-and-slide 0.5s ease-in-out both;\n  opacity: 0;\n  transform: translateY(-20px);\n}\n\n.check {\n  border: 1px solid teal;\n  width: 400px;\n}\n\n@keyframes fade-in-and-slide {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.check {\n  border: 1px solid teal;\n  width: 400px;\n}\n.added-data-list {\n  width: 93%;\n  margin-top: 0.1rem;\n  list-style-type: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.added-data-list li {\n  position: relative;\n  margin-top: 0.5rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  background-color: #f3f3f3;\n}\n\n.added-data-list li .close-icon {\n  position: absolute;\n  top: 50%;\n  right: 0rem;\n  transform: translateY(-50%);\n}\n.close-icon {\n  margin-right: 10px;\n  cursor: pointer;\n  z-index: 5;\n}\n\n.edit-icon:hover svg {\n  color: var(--primary-color);\n  /* cursor: pointer; */\n}\n.no-data {\n  font-size: 27px;\n  margin-top: 40px;\n  font-weight: 500;\n}\n\n.multi-select .dropdown-container {\n  border: 1px solid #ced4da !important;\n}\n\n.multi-select .dropdown-container:focus-within {\n  box-shadow: none !important;\n  border-color: var(--primary-color) !important;\n}\n\n.dropdown-heading-value span {\n  color: #495057 !important;\n}\n.chart-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\nbutton.chakra-button:hover {\n  color: #000;\n  background-color: #fdb508;\n  border-color: #fdb508;\n}\n.addButton {\n  font-size: 22px;\n  color: blue;\n  margin-left: 8px;\n}\n.lead_analytics {\n  border: 2px solid rgb(229, 229, 229);\n  height: 450px;\n}\n.lower_analytics_div {\n  margin: 45px 0;\n  display: flex;\n  justify-content: space-around;\n}\n.lower_analytics_div > div:first-child {\n  padding: 10px 25px;\n  width: 250px;\n  font-weight: bold;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  color: white;\n  cursor: pointer;\n}\n.lower_analytics_div > div:last-child {\n  text-shadow: 1px 1px 1px #000, 3px 3px 5px blue;\n}\n\n.week_div {\n  margin: 10px 0;\n}\n.leads_data_analytics {\n  height: 350px;\n  overflow-y: scroll;\n}\n.list_section {\n  padding-top: 10px;\n}\n.custom_chart {\n  height: 350px;\n  display: flex;\n  justify-content: space-around;\n}\n.custom_chart > div > div {\n  width: 120px;\n  height: 100%;\n}\n.custom_bar {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 5px;\n}\n.heading {\n  display: flex;\n  justify-content: space-around;\n  font-weight: 900;\n  margin-bottom: 10px;\n}\n.icon {\n  font-size: 25px;\n}\n.table_analytics {\n  height: 340px;\n  overflow-y: scroll;\n}\n.table_analytics > div {\n  display: flex;\n  justify-content: space-around;\n}\n.table_analytics > div > div:first-child {\n  padding: 10px 5px;\n  margin-top: 3px;\n  width: 250px;\n  font-weight: bold;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  color: white;\n}\n.table_analytics > div > div:last-child {\n  font-weight: 900;\n  font-size: 28px;\n  text-shadow: 1px 1px 1px #000, 3px 3px 5px blue;\n}\n.monthly_analytics_div {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n}\n.flex {\n  display: flex;\n  justify-content: space-between;\n  font-size: 25px;\n  text-align: center;\n  align-items: center;\n}\n.custom_chart_analytics {\n  border: 2px solid rgb(229, 229, 229);\n  padding: 5px;\n  display: flex;\n  justify-content: space-around;\n}\n\n.custom_bar_analytics {\n  height: 550px;\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 5px;\n}\n.date-range-picker {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.date-range-picker input[type=\"date\"] {\n  margin-left: 15px;\n  font-size: 16px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.date-range-picker button {\n  background-color: #327171;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px;\n  cursor: pointer;\n  font-size: 16px;\n  margin-left: 10px;\n}\n\n.date-range-picker button:hover {\n  background-color: #fdb508;\n}\n.monthly_lead_heading {\n  text-align: center;\n  margin-top: 50px;\n}\n.monthly_lead_heading > h3 {\n  color: black;\n\n  text-shadow: 3px 3px 20px #c3d6c3, -2px 1px 30px #c3d6c3;\n  font-weight: 900;\n}\n.monthly_table_analytics {\n  margin-top: 15px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  column-gap: 10px;\n}\n.monthly_table_analytics > div {\n  display: flex;\n  justify-content: space-around;\n  margin-bottom: 15px;\n  border-bottom: 1px solid #c3d6c3;\n  margin: 10px;\n}\n.monthly_table_analytics > div > div:first-child {\n  width: 80%;\n  text-align: left;\n}\n.monthly_table_analytics > div > div:last-child {\n  width: 20%;\n  text-align: right;\n  font-weight: 700;\n}\n\n.pie_heading {\n  width: 120px;\n  margin: auto;\n  text-align: center;\n  padding: 10px 0;\n  background-color: #219ff3;\n  font-weight: bold;\n  font-size: 24px;\n  color: #fff;\n  text-align: center;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  letter-spacing: 1px;\n}\n.week_days {\n  border: 1px solid teal;\n  padding: 5px 10px;\n  border-radius: 50%;\n  margin: 0 10px;\n}\n.clicked_week_days {\n  background-color: #327171;\n  color: white;\n  font-weight: 700;\n}\n.expert_time {\n  margin-top: 15px;\n}\n.centered-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: calc(100vh - 150px);\n  overflow: auto;\n}\n\n.custom-table {\n  width: 50%;\n  max-width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.custom-table th,\n.custom-table td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n}\n.custom-table th {\n  background-color: #f2f2f2;\n}\n\n.custom-table tr:last-child td {\n  border-bottom: none;\n}\n\n.table-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.time-slots {\n  width: 50%;\n}\n\n.tdEditIcon {\n  cursor: pointer;\n}\n\n.statusCell {\n  display: flex;\n  align-items: center;\n}\n\n.booking-table-th {\n  width: 50% !important;\n  border: 10px solid red;\n}\n\n.expert-pricing-div {\n  margin-top: 50px;\n}\n\n.expert-pricing-lower-div {\n  margin: 50px 0px 0 0;\n  background: #327171;\n  border-radius: 8px;\n}\n.expert-timing-lower-div {\n  border: 1px solid teal;\n  display: flex;\n  justify-content: space-evenly;\n  text-align: center;\n}\n.expert-timing-lower-div > :first-child {\n  width: 100px;\n  height: 80px;\n  border-radius: 50%;\n}\n.expert-timing-lower-div > :first-child > img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n}\n\n.expert-timing-lower-div > :last-child {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n}\n\n.our-team {\n  padding: 20px 0 20px;\n  background: white;\n  text-align: center;\n  overflow: hidden;\n  position: relative;\n  cursor: pointer;\n}\n\n.our-team .pic {\n  display: inline-block;\n  width: 130px;\n  height: 130px;\n  margin-bottom: 50px;\n\n  position: relative;\n  z-index: 1;\n}\n\n.our-team .pic:before {\n  content: \"\";\n  width: 100%;\n  background: #327171;\n  position: absolute;\n  bottom: 135%;\n  right: 0;\n  left: 0;\n  transform: scale(3);\n  transition: all 0.3s linear 0s;\n}\n\n.our-team .pic:before {\n  height: 100%;\n}\n\n.our-team .pic:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  border: radius 50%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n}\n\n.our-team .pic img {\n  width: 100%;\n  height: auto;\n  border-radius: 50%;\n  transform: scale(1);\n  transition: all 0.9s ease 0s;\n}\n\n.our-team .pic img {\n  box-shadow: 0 0 0 14px #efdb07;\n  transform: scale(0.7);\n}\n\n.our-team .team-content {\n  margin-bottom: 50px;\n  /* color: white; */\n}\n\n.our-team .title {\n  font-size: 22px;\n  font-weight: 700;\n  color: white;\n  letter-spacing: 1px;\n  text-transform: capitalize;\n  margin-bottom: 5px;\n  text-shadow: 5px 5px 5px black;\n}\n\n.our-team .post {\n  display: block;\n  font-size: 15px;\n  color: white;\n  text-transform: capitalize;\n  text-shadow: 5px 5px 5px black;\n}\n\n.our-team .social {\n  width: 100%;\n  padding: 10px 0 0 0;\n  margin: 0;\n  background: #327171;\n  position: absolute;\n  bottom: -100px;\n  left: 0;\n  transition: all 0.5s ease 0s;\n}\n\n.our-team .social {\n  bottom: 0;\n}\n\n.our-team .social li {\n  display: inline-block;\n}\n\n.our-team .social li a {\n  display: block;\n  padding: 10px;\n  font-size: 24px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.5s ease 0s;\n}\n\n.our-team .social li a {\n  color: white;\n  text-decoration: none;\n}\n\n.expert_div {\n  background: #327171;\n  /* border: 1px solid red; */\n  border-radius: 4px;\n}\n\n.active-status {\n  font-weight: 700 !important;\n  color: green !important;\n}\n\n.ended-status {\n  font-weight: 700 !important;\n  color: red !important;\n}\n\n.button-icon {\n  font-size: 20px;\n}\n\n.corporate-grid-container {\n  margin-top: 80px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 10px;\n\n  padding: 0 10px;\n}\n\n.corporate-grid-item {\n  padding: 20px;\n  background-color: #f0f0f0;\n  border: 1px solid #ccc;\n  text-align: center;\n}\n.custom-navbar {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 1000;\n  background-color: #f8f9fa;\n  display: grid !important;\n}\n\n.navbar-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.navbar-top .brand {\n  text-align: center;\n  flex: 1;\n}\n\n.navbar-top .logout-btn {\n  flex: 0;\n  margin-left: auto;\n}\n\n.navbar-bottom {\n  padding: 0.5rem 1rem;\n}\n\n@media (max-width: 767px) {\n  .navbar-top {\n    flex-direction: row-reverse;\n    justify-content: space-between;\n  }\n\n  .navbar-top .brand {\n    order: 1;\n    flex: 1;\n    text-align: center;\n  }\n\n  .navbar-top .logout-btn {\n    order: 2;\n  }\n}\n.container-fluid {\n  margin-top: -60px;\n}\n.top_section_container {\n  display: flex;\n  column-gap: 25px;\n}\n\n.expert_container_item {\n  padding: 10px;\n  flex: 1;\n}\n\n.expert_list_button {\n  display: flex;\n  justify-content: right;\n  align-items: center;\n}\n\n.expert_list_button > div {\n  margin-right: 15px;\n}\n.centered_text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n  font-weight: bold;\n  color: #327171;\n}\n\n.expert_centered_text {\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  font-size: 24px;\n  font-weight: bold;\n  color: #327171;\n}\n\n.centered {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.top_section_lower_container {\n  flex: 1;\n}\n.small_item {\n  flex: 0.65;\n}\n\n.wide_item {\n  flex: 1.15;\n}\n\n/* .master_wide_item {\n  flex: 1.15; \n} */\n\n.nested {\n  margin-bottom: 10px;\n}\n\n.nested:last-child {\n  margin-bottom: 0;\n}\n\n.subscription_clear_button {\n  width: 330px;\n}\n\n.single_centered_text {\n  margin-top: 20px;\n  font-size: 30px;\n}\n\n.sheet_btn,\n.sheet_btn:focus {\n  background-color: var(--secondary-color-1);\n  border: 1px solid var(--secondary-color-1);\n}\n\n.sheet_btn:hover {\n  background-color: var(--primary-color) !important;\n  border-color: var(--primary-color) !important;\n  color: var(--white-color);\n}\n\n.small-text {\n  font-size: 0.8em;\n  color: gray;\n  word-break: break-all;\n  overflow-wrap: break-word;\n}\n\n.notification-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.notifications-title {\n  flex-grow: 1;\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: var(--secondary-color-1);\n}\n\n.vertical-buttons {\n  display: flex;\n  flex-direction: column;\n}\n\n.no-data {\n  text-align: center;\n  padding: 1rem;\n}\n\n.notification-table-container {\n  overflow-x: auto;\n  flex: 1;\n  border-left: 2px solid #c6caca;\n  padding-left: 2rem;\n}\n\n.notification-btn {\n  display: block;\n  width: 100%;\n}\n\n.notification-action-btn {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.custom-btn {\n  width: 220px;\n}\n\n.sync-text {\n  font-weight: bold;\n  font-size: small;\n  margin: 5px 5px 5px 10px;\n}\n.sync-subtext {\n  font-weight: normal;\n  font-size: smaller;\n  margin: 5px 5px 5px 10px;\n}\n\n.sync-count {\n  color: #327171;\n}\n\n.info-icon {\n  cursor: pointer;\n}\n\n.info-content {\n  visibility: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  z-index: 10;\n}\n\n.info-icon:hover + .info-content {\n  visibility: visible;\n}\n\n.parent-sync-count {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.lower_parent-booking-count {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  padding-top: 5px;\n}\n\n.mt-records {\n  font-size: 20px;\n  font-weight: bold;\n  color: #327171;\n  margin: 25px 0 50px 0;\n}\n\n.center-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
